interface ChipIconProps {
  size?: number;
  className?: string;
}

/**
 * Stylised poker-chip glyph used for the internal "фишки" (chips) balance.
 * Deliberately distinct from Telegram's ⭐ so users don't conflate the two —
 * Telegram Stars are *one* of several ways to buy chips, never the chips themselves.
 */
export function ChipIcon({ size = 16, className }: ChipIconProps) {
  const id = `chip-grad-${size}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      fill="none"
    >
      <defs>
        <radialGradient id={id} cx="50%" cy="42%" r="55%">
          <stop offset="0%" stopColor="#F5D78A" />
          <stop offset="55%" stopColor="#C9A05C" />
          <stop offset="100%" stopColor="#8B6A2A" />
        </radialGradient>
      </defs>
      {/* Outer chip */}
      <circle cx="12" cy="12" r="10.5" fill={`url(#${id})`} stroke="#7A5A1F" strokeWidth="0.7" />
      {/* Edge notches — four cardinal points */}
      <rect x="11" y="0.8" width="2" height="2.4" fill="#3F2F0E" rx="0.3" />
      <rect x="11" y="20.8" width="2" height="2.4" fill="#3F2F0E" rx="0.3" />
      <rect x="0.8" y="11" width="2.4" height="2" fill="#3F2F0E" rx="0.3" />
      <rect x="20.8" y="11" width="2.4" height="2" fill="#3F2F0E" rx="0.3" />
      {/* Inner ring */}
      <circle cx="12" cy="12" r="6.6" fill="none" stroke="#7A5A1F" strokeWidth="0.7" />
      {/* Inner glow */}
      <circle
        cx="12"
        cy="12"
        r="5.4"
        fill="#FBE6A8"
        opacity="0.55"
      />
      {/* Subtle highlight */}
      <ellipse cx="9.5" cy="8.5" rx="3.2" ry="1.4" fill="#FFFFFF" opacity="0.35" />
    </svg>
  );
}
